import { WidgetFeature } from 'enums/WidgetFeature';
import { useSelector } from 'react-redux';
import { selectFeatureEnabled } from 'state/features/features.selectors';

export const useFeatureToggle = (feature: WidgetFeature) =>
    !!useSelector((state) => selectFeatureEnabled(state, feature));
